import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = ({ onAccept, onReject }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    onAccept();
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setIsVisible(false);
    onReject(); // Only necessary cookies, no analytics
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-header">
          <h3>🍪 Cookie Settings</h3>
        </div>
        
        <div className="cookie-consent-content">
          <p className="cookie-main-text">
           My website uses cookies to help me analyze site traffic 
            using Google Analytics.
          </p>

          {showDetails && (
            <div className="cookie-details">
              <div className="cookie-category">
                <h4>Necessary Cookies (Always Active)</h4>
                <p>
                  These cookies are essential for the website to function and remember your 
                  cookie preferences.
                </p>
              </div>
              
              <div className="cookie-category">
                <h4>Analytics Cookies (Optional)</h4>
                <p>
                  I use Google Analytics to understand how visitors interact with my website. 
                  This helps me improve the user experience. These cookies collect anonymous 
                  information including visitor count, traffic sources, and page views.
                </p>
                <p className="cookie-provider">
                  Provider: Google Analytics (Google LLC)
                </p>
              </div>

              <div className="cookie-links">
                <a 
                  href="https://policies.google.com/privacy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="cookie-policy-link"
                >
                  Google Privacy Policy
                </a>
              </div>
            </div>
          )}

          <button 
            className="cookie-details-toggle"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? '▼ Show Less' : '▶ Show Details'}
          </button>
        </div>

        <div className="cookie-consent-actions">
          <button 
            className="cookie-btn cookie-btn-reject"
            onClick={handleAcceptNecessary}
          >
            Necessary Only
          </button>
          <button 
            className="cookie-btn cookie-btn-accept"
            onClick={handleAccept}
          >
            Accept All
          </button>
        </div>

        <p className="cookie-footer-text">
          You can change your preferences at any time by clearing your browser cookies.
        </p>
      </div>
    </div>
  );
};

export default CookieConsent;